import { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import Pagination from "../components/common/Pagination";
import { hideModal, showModal } from "../utils/modalUtility";
import useAxios from "../utils/useAxios";
import config from "../config";
import { truncateWords } from "../utils/currencyFormat";
import Select from "react-select";
import RichTextEditor from "../components/common/TipTapEditor";

const Transcripts = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [projects, setProjects] = useState([]);

  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [mediaType, setMediaType] = useState("video"); // 'image' or 'video'
  const [selectedPreview, setSelectedPreview] = useState(null); //  preview URL

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [media, setMedia] = useState([]);
  const [mediaPage, setMediaPage] = useState(1); // NEW (Media pagination)
  const [hasMore, setHasMore] = useState(true);

  const [location, setLocation] = useState([]);
  const [category, setCategory] = useState([]);

  const [slugError, setSlugError] = useState("");
  const [originalSlug, setOriginalSlug] = useState("");

  const axiosAPI = useAxios();
  const BASE_URL = config?.apiBaseUrl;

  const initialFormData = {
    name: "",
    description: "",
    audio: "YES",
    publish_date: "",
    mediaIds: [],
    slug: "",
    location_ids: [],
    category_ids: [],
    url: "",
    // content: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  function removeFormData() {
    setFormData(initialFormData);
  }
  // const handleChange = (e) => {
  //   const { id, value } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [id]: value,
  //   }));
  // };

  // const handleChange = (e) => {
  //   const { id, value } = e.target;

  //   setFormData((prev) => {
  //     if (id === "audio" && value === "NO") {
  //       return {
  //         ...prev,
  //         audio: value,
  //         url: "", // clear audio url
  //       };
  //     }

  //     return {
  //       ...prev,
  //       [id]: value,
  //     };
  //   });
  // };

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => {
      let updatedData = { ...prev, [id]: value };

      // Auto-generate slug from name
      if (id === "name") {
        updatedData.slug = value.toLowerCase().trim().replace(/\s+/g, "-");
      }

      // If audio = NO, clear url
      if (id === "audio" && value === "NO") {
        updatedData.url = "";
      }

      return updatedData;
    });
  };

  const handleCheckboxChange = (id, file_path) => {
    // console.log("id and file path", id, file_path);

    setFormData((prevFormData) => {
      const alreadySelected = prevFormData.mediaIds.includes(id);

      let updatedMediaIds;

      // const updatedMediaIds = alreadySelected
      //   ? prevFormData.mediaIds.filter((item) => item !==   id) // deselect
      //   : [...prevFormData.mediaIds, id]; // select

      if (alreadySelected) {
        // Deselect
        updatedMediaIds = prevFormData.mediaIds.filter((item) => item !== id);
      } else {
        // Select
        updatedMediaIds = [...prevFormData.mediaIds, id];
      }
      //  Check if it's the first selected item (after adding)
      let newThumbnailUrl = prevFormData.thumbnail_url;

      if (!alreadySelected && prevFormData.mediaIds.length === 0) {
        // newThumbnailUrl = "/" + file_path;
        newThumbnailUrl = file_path;
      }

      // If first item is deselected, reset thumbnail_url (optional)
      if (alreadySelected && id === prevFormData.mediaIds[0]) {
        // Optional: You can reset or set to next selected item
        newThumbnailUrl = updatedMediaIds.length > 0 ? null : "";
      }

      return {
        ...prevFormData,
        mediaIds: updatedMediaIds,
        thumbnail_url: newThumbnailUrl,
      };
    });
  };

  // Get All Media
  const getMedia = async (pageNumber) => {
    try {
      setLoading(true);

      const response = await axiosAPI.get(
        `/api/media/get-media?page=${pageNumber}`,
      );

      const newMedia = response.data.data;

      setMedia((prev) =>
        pageNumber === 1 ? newMedia : [...prev, ...newMedia],
      );

      setHasMore(pageNumber < response.data.totalPages);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  async function validateSlugUnique(slug) {
    try {
      const response = await axiosAPI.get(
        `/api/transcript/check-slug-exist/${slug}`,
      );

      if (response.data.success) {
        // Slug is available
        setSlugError(""); // Clear error
        return true; // valid slug
      } else {
        // Slug already exists
        setSlugError(
          response.data.message ||
            "Slug already exists. Please choose a different one.",
        );
        return false; // invalid slug
      }
    } catch (error) {
      console.error("Error checking slug:", error);
      setSlugError("Error checking slug. Please try again.");
      return false; // consider invalid on error
    }
  }

  async function fetchBlog() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/transcript/all?page=${page}`);
      setProjects(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  async function fetchLocations() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/location/all`);
      setLocation(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  const locationOptions = location?.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  const catgeoryOptions = category?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    if (!formData.slug) {
      setSlugError("Slug is required");
      return;
    }

    if (!isEditMode || formData.slug !== originalSlug) {
      const isSlugValid = await validateSlugUnique(formData.slug);
      if (!isSlugValid) {
        setLoading(false); // important
        return;
      }
    }

    const payload = {
      name: formData.name,
      description: formData.description,
      media_ids: formData.mediaIds,
      audio: formData.audio,
      publish_date: formData.publish_date,
      location_ids: formData.location_ids,
      url: formData.url,
      slug: formData.slug,
      category_ids: formData.category_ids,
    };

    console.log("Payload to ", payload);

    // setLoading(false);

    // return;

    try {
      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/transcript/${currentProjectId}`,
          payload,
        );

        window.notifyMessage(
          "Success",
          "Transcript details updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post(`/api/transcript`, payload);
        window.notifyMessage(
          "Success",
          "Transcript details added successfully",
          "success",
        );
      }
      setIsEditMode(false);
      hideModal("newUserModal");
      removeFormData();
      fetchBlog(); // refresh list
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", errorMsg, "danger");
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  const selectMediaFileToSend = (
    index,
    thumbnail_url,
    media_url,
    media_type,
  ) => {
    // console.log("Selected Media:");

    if (selectedItems.includes(index)) {
      setSelectedItems([]);
      setSelectedPreview(null);
    } else {
      setSelectedItems([index]);
      setSelectedPreview({
        thumbnail_url,
        media_url,
        media_type,
      });

      // console.log("Selected Preview Set:", {
      //   thumbnail_url,
      //   media_url,
      //   media_type,
      // });
    }
  };

  async function fetchCategory() {
    try {
      setLoading(true);
      const response = await axiosAPI.get("/api/categories?category_type_id=3");

      const categories = response?.data?.categories;

      const limitedData = categories?.map(({ id, name }) => ({
        id,
        name,
      }));

      setCategory(limitedData);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  const openEditModal = async (productId) => {
    setIsEditMode(true);
    setCurrentProjectId(productId);
    showModal("newUserModal");
    // console.log("user id", productId);

    // const blogDetails =  await axiosAPI.get(`/api/blogs/${productId}`);
    // console.log("Blog Details", blogDetails.data.blog);

    const productToEdit = projects.find((product) => product.id === productId);

    // console.log(productToEdit);
    const media_ids = productToEdit?.media_ids;

    // console.log({ media_ids });
    let mediaArray = [];

    // Convert to array of strings: ["4", "3"]
    if (media_ids) {
      mediaArray = media_ids?.split(",");
    }
    // Optional: Convert to array of numbers: [4, 3]
    const mediaIdNumbers = mediaArray?.map(Number);

    // console.log("Media ids", media_ids);
    // console.log("Product to edit", productToEdit);

    setFormData({
      name: productToEdit.name || "",
      description: productToEdit.description || "",
      mediaIds: mediaIdNumbers,
      location_ids: productToEdit.location_ids,
      category_ids: productToEdit.category_ids,
      audio: productToEdit.audio,
      publish_date: productToEdit.publish_date,
      url: productToEdit?.url,
      slug: productToEdit.slug,
    });
    setOriginalSlug(productToEdit.slug);
  };

  // console.log("FormData", formData);

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/transcript/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchBlog();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // console.log("fomrData", formData);

  async function changeTranscriptStatus(e, projectId) {
    const currentStatus = e.target.value;

    // console.log("product  Id", blogId);
    // console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the transcript card status?",
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/transcript/change-status/${projectId}`,
        { status: currentStatus },
      );

      fetchBlog();
      window.notifyMessage(
        "Success",
        "Transcript status changed successfully",
        "success",
      );
    } catch (error) {
      console.error("Error changing transcript status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change transcript status. Please try again.",
        "danger",
      );
    }
  }

  function openMediaLibraryModal() {
    // setMedia([]);
    setHasMore(true); // Reset button
    setMediaPage(1); // Trigger API
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }
  function openBlogModal() {
    showModal("newUserModal");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentProjectId(null);
  };

  const handleLoadMore = () => {
    setMediaPage((prev) => prev + 1);
  };

  const handleContentChange = (value) => {
    setFormData((prev) => ({ ...prev, description: value }));
  };

  useEffect(() => {
    // console.log("Inside")
    getMedia(mediaPage);
  }, [mediaPage]);
  // useEffect(() => {
  //   getMedia();
  // }, []);

  useEffect(() => {
    fetchBlog();
    fetchLocations();
    fetchCategory();
  }, []);

  useEffect(() => {
    fetchBlog();
  }, [page]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openBlogModal()}
            >
              Add Transcript
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Transcript" : "Add Transcript"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Blog Title */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter transcript name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Slug */}
                  <div className="mb-3">
                    <label htmlFor="slug" className="form-label">
                      Slug *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="slug"
                      placeholder="Enter transcript slug"
                      value={formData.slug}
                      onChange={handleChange}
                      required
                    />

                    {slugError && (
                      <small className="text-danger">{slugError}</small>
                    )}
                  </div>

                  <div className="row">
                    {/* Left Side - Locations */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="location_ids" className="form-label">
                          Locations
                        </label>
                        <Select
                          id="location_ids"
                          options={locationOptions}
                          isMulti
                          value={locationOptions.filter((option) =>
                            (formData.location_ids || []).includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const newIds =
                              selectedOptions?.map((opt) => opt.value) || [];
                            setFormData({
                              ...formData,
                              location_ids: newIds,
                            });
                          }}
                          placeholder="Select locations"
                          isClearable
                        />
                      </div>
                    </div>

                    {/* Right Side - Categories */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="category_ids" className="form-label">
                          Categories
                        </label>
                        <Select
                          id="category_ids"
                          options={catgeoryOptions}
                          isMulti
                          value={catgeoryOptions.filter((option) =>
                            (formData.category_ids || []).includes(
                              option.value,
                            ),
                          )}
                          onChange={(selectedOptions) => {
                            const newIds =
                              selectedOptions?.map((opt) => opt.value) || [];
                            setFormData({
                              ...formData,
                              category_ids: newIds,
                            });
                          }}
                          placeholder="Select Category"
                          isClearable
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="audio" className="form-label">
                          Is Audio Available?
                        </label>

                        <select
                          className="form-select"
                          id="audio"
                          value={formData.audio || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Option</option>
                          <option value="YES">Yes</option>
                          <option value="NO">No</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="publish_date" className="form-label">
                          Publish Date
                        </label>

                        <input
                          type="date"
                          className="form-control"
                          id="publish_date"
                          name="publish_date"
                          value={formData.publish_date || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Only show when audio === "YES" */}
                  {formData.audio === "YES" && (
                    <div className="mb-3">
                      <label htmlFor="url" className="form-label">
                        Audio Url
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="url"
                        placeholder="Enter audio url"
                        value={formData.url || ""}
                        onChange={handleChange}
                      />
                    </div>
                  )}

                  {/* <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description *
                    </label>

                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      placeholder="Enter transcript description"
                      value={formData.description}
                      onChange={handleChange}
                      rows="4"
                      required
                    />
                  </div> */}

                  <div>
                    <label htmlFor="content" className="form-label">
                      Content *
                    </label>
                    <RichTextEditor
                      content={formData.description}
                      onChange={handleContentChange}
                    />
                  </div>

                  <h6>Total Media selected : {formData.mediaIds?.length}</h6>
                  <div className="dropdown mb-3">
                    <button
                      className="btn theme-secondary-button btn-sm btn-rounded"
                      type="button"
                      id="dropdownMenuButton"
                      onClick={openMediaLibraryModal}
                      aria-expanded="false"
                    >
                      <i className="fas fa-photo-video me-1"></i>
                      Select Media From Gallery
                    </button>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn theme-secondary-button btn-sm btn-rounded"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={closeModal}
                    >
                      Close
                    </button>
                  </div>
                  <button
                    type="submit"
                    className="btn theme-button btn-sm btn-rounded"
                    disabled={loading}
                  >
                    {loading ? (
                      <FaSpinner className="spinner" spin />
                    ) : isEditMode ? (
                      "Update Transcript"
                    ) : (
                      "Add Transcript"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="customModal"
          tabIndex="-1"
          aria-labelledby="customModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="customModalLabel">
                  {mediaType === "video" ? "Media Library" : "Media Library"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {/* Top Bar */}
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <input
                    type="text"
                    className="form-control w-50"
                    placeholder="Search media..."
                    // onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                {/* Upload Section */}
                <div className="media-grid row">
                  {media?.map((item, index) => {
                    const isChecked = formData.mediaIds?.includes(item.id);

                    return (
                      <div className="col-md-3 mb-4" key={index}>
                        <div className="card h-100">
                          <div className="position-relative">
                            {/* Show image or video based on type */}
                            {item.media_type === "video" ? (
                              <video
                                src={`${BASE_URL}${item.file_path}`}
                                controls
                                loop
                                muted
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            ) : (
                              <img
                                src={`${BASE_URL}${item?.file_path}`}
                                alt={item.media_name}
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            )}

                            {/* Checkbox */}
                            <div className="position-absolute top-0 end-0 p-2">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  handleCheckboxChange(item.id, item.file_path)
                                }
                              />
                            </div>
                          </div>

                          <div className="card-body p-2 text-center">
                            <small className="text-muted">
                              {item.media_name}
                            </small>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* Modal Inside Contain Image and Video */}
                {/* <div className="row g-3"> */}
                <div>
                  {uploadedMedia
                    .filter((item) => item.media_type === mediaType)
                    .map((item, index) => {
                      const isSelected = selectedItems.includes(index);
                      return (
                        <div className="col-6 col-md-3" key={index}>
                          <div
                            className="border rounded p-2 text-center position-relative"
                            style={{
                              cursor: "pointer",
                              maxWidth: "180px",
                              height: "130px",
                              margin: "0 auto",
                            }}
                            onClick={() =>
                              selectMediaFileToSend(
                                index,
                                item.thumbnail_url,
                                item.media_url,
                                item.media_type,
                              )
                            }
                          >
                            {/*  Fixed Selection Box */}
                            <div
                              style={{
                                position: "absolute",
                                top: "5px",
                                left: "5px",
                                width: "20px",
                                height: "20px",
                                backgroundColor: "white",
                                border: "2px solid #999",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2,
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {isSelected ? "" : ""}
                            </div>

                            {item.media_type === "image" ? (
                              <img
                                src={item.thumbnail_url}
                                alt={`media-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain", // contain or contain based on your need
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <video
                                src={item.media_url}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain",
                                  borderRadius: "4px",
                                }}
                                muted
                                loop
                                playsInline
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>

                {hasMore && (
                  <div className="text-center mt-3 mb-3">
                    <button
                      className="btn theme-button btn-sm btn-rounded"
                      onClick={handleLoadMore}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  </div>
                )}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn theme-secondary-button btn-sm btn-rounded"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn theme-button btn-sm btn-rounded"
                    // data-bs-toggle="modal"
                    // data-bs-target="#customModal"
                    onClick={handleMediaSumbit}
                    // disabled={!selectedPreview}
                  >
                    Select Media From Library
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Blogs Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Transcript ({projects?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr no</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Slug</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : projects?.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No transcript found.
                          </td>
                        </tr>
                      ) : (
                        projects &&
                        projects?.map((project, index) => (
                          <tr key={project.id}>
                            <td>{index + 1}</td>
                            <td>{project?.name}</td>
                            <td>{truncateWords(project?.description, 10)}</td>
                            <td>{project?.slug}</td>
                            <td>
                              <select
                                className="form-select"
                                value={project.is_active_or_inactive}
                                onChange={(e) =>
                                  changeTranscriptStatus(e, project?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td>
                            <td>
                              {new Date(
                                project?.created_at_utc + "Z",
                              )?.toLocaleString()}
                            </td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(project.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(project.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transcripts;
